import React from 'react';
import { DatePicker, Input, Button, Space, Card } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

interface QueryParamsProps {
  dateRange: [Dayjs | null, Dayjs | null] | null;
  vendorFrom: string;
  vendorTo: string;
  loading: boolean;
  onDateRangeChange: (range: [Dayjs | null, Dayjs | null] | null) => void;
  onVendorFromChange: (value: string) => void;
  onVendorToChange: (value: string) => void;
  onQuery: () => void;
  onReset: () => void;
}

const QueryParamsPanel: React.FC<QueryParamsProps> = ({
  dateRange,
  vendorFrom,
  vendorTo,
  loading,
  onDateRangeChange,
  onVendorFromChange,
  onVendorToChange,
  onQuery,
  onReset,
}) => {
  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap size="middle" style={{ width: '100%' }}>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 4 }}>日期範圍</label>
          <RangePicker
            value={dateRange}
            onChange={(val) => onDateRangeChange(val as [Dayjs | null, Dayjs | null] | null)}
            style={{ width: 260 }}
            allowClear
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 4 }}>廠商代號起</label>
          <Input
            value={vendorFrom}
            onChange={(e) => onVendorFromChange(e.target.value)}
            placeholder="起始廠商"
            style={{ width: 130 }}
            allowClear
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 4 }}>廠商代號迄</label>
          <Input
            value={vendorTo}
            onChange={(e) => onVendorToChange(e.target.value)}
            placeholder="結束廠商"
            style={{ width: 130 }}
            allowClear
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end', paddingTop: 18 }}>
          <Space>
            <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
              查詢
            </Button>
            <Button icon={<ClearOutlined />} onClick={onReset}>
              清除
            </Button>
          </Space>
        </div>
      </Space>
    </Card>
  );
};

export default QueryParamsPanel;
